'use client'

import copyToClipboard from './copyToClipboard'
import notifyServerAndCopy from './notifyServerAndCopy'

export { copyToClipboard }
export { notifyServerAndCopy }

const copyLinkService = {
  copyToClipboard,
  notifyServerAndCopy
}

export default copyLinkService
